import React, { useState } from 'react';
import css from './PackagesBenefitsModal.css';
import ControlElemZoomIn from '../../components/SearchMap/components/ControlElemZoomIn';
import ControlElemZoomOut from '../../components/SearchMap/components/ControlElemZoomOut';
import GoogleMapPreview from '../../forms/EntityLocationFormFields/GoogleMapPreview';
import { useSelector } from 'react-redux';

export default ({ currentListing, isProfilePackageType }) => {
    const currentUser = useSelector(s => s.user.currentUser);
    const { userLocation } = currentUser?.attributes?.profile?.publicData || {};

    const { geolocation: listingGeoLocation } = currentListing?.attributes || {};

    const [zoom, setZoom] = useState(15);

    const geolocation = listingGeoLocation || userLocation;

    return (
        <>
            <h3 className={css.title}>Erhalte mehr Sichtbarkeit über unsere Socials</h3>
            <p className={css.description}>
                {isProfilePackageType
                    ? 'Dein Profil wird im Umkreis von 15 km der Wohnadresse aktiv beworben.'
                    : 'Das Pferde-Profil wird im Umkreis von 15 km der Stalladresse aktiv beworben.'}
            </p>
            {geolocation && (
                <div>
                    <GoogleMapPreview
                        geolocationMaybe={{
                            origin: geolocation,
                        }}
                        rootClassName={css.mapPreviewHolder}
                        mapCustomProps={{
                            zoom,
                        }}
                    >
                        <ControlElemZoomIn
                            setZoom={setZoom}
                            zoom={zoom}
                            rootClassName={css.zoomIn}
                        />
                        <ControlElemZoomOut
                            setZoom={setZoom}
                            zoom={zoom}
                            rootClassName={css.zoomOut}
                        />
                    </GoogleMapPreview>
                    <p className={css.sidenote}>
                        Geschätzte Reichweite basierend auf einer Laufzeit von 7 Tagen.
                    </p>
                    <div className={css.badgesWrapper}>
                        <div className={css.badgesHolder}>
                            <div>Facebook</div> <div>6’000 - 9’000 Personen</div>
                        </div>
                        <div className={css.badgesHolder}>
                            <div>Instagram</div> <div>2’000 - 4’000 Personen</div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
